import { gql } from '@apollo/client';
import IconArrowRight from '@apollo/icons/default/IconArrowRight.svg';
import { Code, Group, ListItem } from '@apollo/orbit';
import React from 'react';
import { Link } from 'react-router-dom';

import { launchesRouteConfig } from 'src/app/graph/routes';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { LaunchesListInfo } from '../helpers/computeLaunchesListInfo';
import { LaunchStepStatusFragment } from '../helpers/stepStatus';
import { LaunchesListStatusIcon } from '../LaunchesListStatusIcon';

export const LaunchesListItemFragment = gql`
  fragment LaunchesListItemFragment on Launch {
    id
    graphId
    graphVariant
    shortenedID
    ...LaunchStepStatusFragment
  }
  ${LaunchStepStatusFragment}
`;

export interface LaunchesListItemInfo {
  launch: GraphQLTypes.LaunchesListItemFragment;
  progress: 'waiting' | 'success' | 'failure';
  status: string;
  isStarted: boolean;
}

type Props = {
  kind: LaunchesListInfo['kind'];
  launchInfo: LaunchesListItemInfo;
  linkLaunch?: boolean;
};

export const LaunchesListItem = ({
  kind,
  launchInfo: { launch, progress, status },
  linkLaunch,
}: Props) => {
  return (
    <ListItem
      as={linkLaunch ? Link : undefined}
      className="group"
      to={launchesRouteConfig.location({
        graphId: launch.graphId,
        graphVariant: launch.graphVariant,
        launchId: launch.id,
      })}
    >
      <Group justify="between">
        <Group>
          <LaunchesListStatusIcon progress={progress} />
          <div className="text-sm text-neutral">
            <span className="font-semibold">{launch.graphVariant}</span>{' '}
            {kind === 'supersede' ? `superseding schema` : `contract schema`}{' '}
            {status}
          </div>
          <Code>{launch.shortenedID}</Code>
        </Group>
        {linkLaunch && (
          <div className="flex items-center justify-end opacity-0 group-hover:opacity-100">
            <IconArrowRight className="text-placeholder" />
          </div>
        )}
      </Group>
    </ListItem>
  );
};
